import { render, staticRenderFns } from "./projectTable.vue?vue&type=template&id=c7c7fbd0"
import script from "./projectTable.vue?vue&type=script&lang=js"
export * from "./projectTable.vue?vue&type=script&lang=js"
import style0 from "./projectTable.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports